import styled from 'styled-components';
import { Flex } from '../../common/common-components.styled';

export const StyledConfigurationFromPdf = styled(Flex)`
  flex-direction: column;
  @media (min-width: ${({ theme }) => theme.media.tabletHorizontal}) {
    flex-direction: row;
  }
`;

export const StyledLeftContainer = styled.div`
  width: 100%;
  order: 1;
  @media (min-width: ${({ theme }) => theme.media.tabletHorizontal}) {
    order: 0;
    flex-direction: row;
  }
`;

export const StyledRightContainer = styled.div`
  width: 100%;
  order: 0;
  @media (min-width: ${({ theme }) => theme.media.tabletHorizontal}) {
    order: 1;
    flex-direction: row;
  }
`;
